module.exports = __webpack_public_path__ + "img/Icon_Facebook.1f338836.svg";